import PropTypes from 'prop-types'
import React from 'react'
import { useFormikContext } from 'formik'
import { Password, PhoneInputWithSelectDial } from 'SRC/ui/FormElementsNew'
import { connect } from 'react-redux'
import config from 'SRC/config/config.json'

import { getCountries } from 'SRC/modules/geoObjects/countries/selectors'

const AuthFormPhone = ({ isActive, countries }) => {
  const formik = useFormikContext()

  if (!formik || !formik.values) return null

  const prepareCountries = () => Array.isArray(countries)
    ? countries.filter(country => !country.parent).map(country => {
      const isGrouped = Boolean(countries.filter(item => item.parent === country.id).length)
      return {
        id: `${country.id}`,
        label: country.label,
        value: `${country.id}`,
        dial: `${country.dial}`,
        isGrouped,
        options: isGrouped ? countries.filter(item => item.parent === country.id).map(childCountry => ({
          id: `${childCountry.id}`,
          value: `${childCountry.id}`,
          label: childCountry.label,
          dial: `${childCountry.dial}`
        })) : null
      }
    })
    : []

  return (
    <div className={`kontakt-podaci-content ${isActive ? `active` : ``}`}>
      <div>
        <PhoneInputWithSelectDial
          label={config.loginForm.labels.phone}
          isFullWidth={false}
          inputClass='form-group__login-phone'
          field={{ name: 'existingUser.phone' }}
          form={formik}
          countries={prepareCountries()}
          wrapperClass='form-group registracija-existing-user'
          isAddAdExistingUser
        />

        <Password formikProps={formik} isAddAdExistingUser name='existingUser.password' />
      </div>
    </div>
  )
}

AuthFormPhone.propTypes = {
  countries: PropTypes.array.isRequired,
  isActive: PropTypes.bool.isRequired
}

AuthFormPhone.defaultProps = {
  isActive: false
}

const mapStateToProps = state => {
  return {
    countries: getCountries(state)
  }
}

export default connect(mapStateToProps)(AuthFormPhone)
